import createVueApp from '@/common/create_app'

Styxie.Initializers.GmbBulkPosts = {
  index: async(props) => {
    const { default: BulkPostsIndex } = await import('@/vue_widgets/gmb/bulk_posts/index.vue')
    createVueApp(BulkPostsIndex, { props })
  },
  show: async(props) => {
    const { default: BulkPostsShow } = await import('@/vue_widgets/gmb/bulk_posts/show.vue')
    createVueApp(BulkPostsShow, { props })
  }
}
